/**
 * Multicolumn Icon Swipe Animation
 * Shows swipe indicator for clickable icons to indicate interactivity
 * Inspired by quick-comparison-table implementation
 */

class MulticolumnIconSwipe {
  constructor(config = {}) {
    this.config = {
      indicatorSize: 45,
      storageKey: 'multicolumn-icon-interacted',
      debug: false,
      ...config
    };
    
    this.svgContent = window.multicolumnHandSVG;
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeSwipeIndicators());
    } else {
      this.initializeSwipeIndicators();
    }
  }



  initializeSwipeIndicators() {
    const isProductPage = document.body.classList.contains('template-product') || 
                         window.location.pathname.includes('/products/');
    
    if (!isProductPage || !this.svgContent) return;
    
    const targetSection = document.querySelector('.product__block--multicolumn_icons .multicolumn-icon:has([data-multicolumn-card-wrapper="taksit-secenekleri"])');
    
    if (targetSection) {
      this.setupSwipeIndicator(targetSection);
    }
  }

  setupSwipeIndicator(section) {

    const swipeIndicator = this.createSwipeIndicator();
    section.appendChild(swipeIndicator);

    const showIndicator = () => {
      const targetCard = this.findTargetCard(section);
      const iconImage = targetCard?.querySelector('img.multicolumn-card--img');
      
      if (!targetCard || !iconImage) return;
      
      const sectionRect = section.getBoundingClientRect();
      const iconRect = iconImage.getBoundingClientRect();
      
      swipeIndicator.style.cssText += `
        position: absolute;
        left: ${iconRect.left - sectionRect.left + (iconRect.width / 2)}px;
        top: ${iconRect.top - sectionRect.top + (iconRect.height / 2)}px;
        transform: translate(-50%, -50%);
        opacity: 1;
        display: flex;
      `;

      const handIcon = swipeIndicator.querySelector('.multicolumn-hand-icon');
      
      const sectionElement = section.closest('.shopify-section');
      let animationSpeed = '2s'; // default
      if (sectionElement && sectionElement.querySelector('[data-animation-duration]')) {
        const duration = parseFloat(sectionElement.querySelector('[data-animation-duration]').dataset.animationDuration) || 5;
        // Convert duration to animation speed: longer duration = slower animation
        animationSpeed = Math.max(0.5, Math.min(4, duration / 2.5)) + 's';
      }
      
      handIcon.style.cssText += `
        -webkit-animation: multicolumnTapDown ${animationSpeed} ease-in-out infinite;
        animation: multicolumnTapDown ${animationSpeed} ease-in-out infinite;
        -webkit-transform-origin: center center;
        transform-origin: center center;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        will-change: transform, opacity;
      `;
    };

    const hideIndicator = (remember = true) => {
      swipeIndicator.style.opacity = '0';
      setTimeout(() => swipeIndicator.remove(), 300);
      if (remember) localStorage.setItem(this.config.storageKey, Date.now().toString());
    };

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setTimeout(() => {
          showIndicator();
          this.setupEventListeners(section, hideIndicator);
          let animationDuration = 5000; // default
          
          if (section.dataset.animationDuration) {
            animationDuration = parseInt(section.dataset.animationDuration) * 1000;
          } else {
            const sectionElement = section.closest('.shopify-section');
            if (sectionElement && sectionElement.dataset.animationDuration) {
              animationDuration = parseInt(sectionElement.dataset.animationDuration) * 1000;
            }
          }
          
          setTimeout(() => {
            hideIndicator(false);
          }, animationDuration);
        }, 500);
        observer.disconnect();
      }
    }, { threshold: 0.3 });

    observer.observe(section);
  }

  findTargetCard(section) {
    return section.querySelector('[data-multicolumn-card-wrapper="taksit-secenekleri"]');
  }

  setupEventListeners(section, hideCallback) {
    const hideOnInteraction = (e) => {
      if (e.target.closest('.aph_pop_pop')) {
        return;
      }
      hideCallback(true);
    };
    
    document.addEventListener('click', hideOnInteraction, { once: true, passive: true });
    section.addEventListener('touchstart', hideOnInteraction, { once: true, passive: true });
    window.addEventListener('resize', () => hideCallback(false), { once: true });
  }

  createSwipeIndicator() {
    const indicator = document.createElement('div');
    indicator.className = 'multicolumn-swipe-indicator';
    indicator.style.cssText = `
      position: absolute;
      width: ${this.config.indicatorSize}px;
      height: ${this.config.indicatorSize}px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.95);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      pointer-events: none;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
      opacity: 0;
      transition: opacity 0.3s ease;
    `;
    
    const handIcon = document.createElement('div');
    handIcon.className = 'multicolumn-hand-icon';
    handIcon.style.cssText = `display: flex; align-items: center; justify-content: center; color: #333;`;
    handIcon.innerHTML = this.svgContent;
    
    indicator.appendChild(handIcon);
    return indicator;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MulticolumnIconSwipe();
});